import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseButton } from '@repo/common';
import { setStandardCareer } from '../../../api/career/career.api';

const CreateResumeSuccessBottom = ({ resumeId, buttonLabel, title }) => {
  const navigate = useNavigate();

  const handleApplyClick = async () => {
    try {
      await setStandardCareer(resumeId);

      setTimeout(() => {
        navigate('/jobs', {
          state: {
            from: 'resume-success',
          },
        });
      }, 400);
    } catch (e) {
      alert('대표 이력서 설정 중 오류 발생');
    }
  };

  return (
    <>
      <div className='tabletH:w-[274px] flex flex-col items-center gap-2 w-full'>
        <BaseButton
          type='primary'
          size='xl'
          width='100%'
          hideIcon
          onClick={handleApplyClick}
        >
          {buttonLabel}
        </BaseButton>

        <div className='typo-b12 text-text-placeholder text-center'>
          {title}
        </div>
      </div>
    </>
  );
};

export default CreateResumeSuccessBottom;
